import { render, staticRenderFns } from "./CustomerCreate.vue?vue&type=template&id=7a37b37c&"
import script from "./CustomerCreate.vue?vue&type=script&lang=js&"
export * from "./CustomerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports